import React from "react";
import { CheckCircle, Warning, WarningCircle } from "@phosphor-icons/react";

const SRC = {
  main: ["Main", "bg-black text-white"], buyer: ["Buyer", "bg-sky-100"],
  extra: ["Extra", "bg-violet-100"], tracking: ["Media buyer", "bg-amber-100"],
};
const KIND = { meta: "Meta", google_ads: "Google Ads", ga4: "GA4", tiktok: "TikTok", custom: "Code" };
const KIND_TAG = { shared: "Shared page", buyer: "Buyer", own: "Buyer's own page" };
export const STATUS = {
  fail: [WarningCircle, "text-red-600", "Broken"], warn: [Warning, "text-amber-600", "Check"], ok: [CheckCircle, "text-emerald-600", "Working"],
};

function Chip({ p }) {
  const [label, cls] = SRC[p.source];
  return (
    <span title={p.note || ""} data-testid={`pixel-chip-${p.source}-${p.kind}`}
          className={`border border-black px-1.5 py-0.5 text-[10px] whitespace-nowrap ${p.ok ? cls : "bg-red-600 text-white"} ${p.loads === false ? "opacity-50 line-through" : ""}`}>
      {label} · {KIND[p.kind]} {p.id}
    </span>
  );
}

function Live({ v, testId }) {
  if (!v) return <span className="text-[10px] text-zinc-400" data-testid={testId}>Not live-tested</span>;
  return v.ok
    ? <span className="text-[10px] text-emerald-700 font-bold" data-testid={testId}>Live: pixels loaded</span>
    : <span className="text-[10px] text-red-700 font-bold" data-testid={testId}>Live: {v.problem}</span>;
}

function Surface({ title, items, live, href, testId }) {
  return (
    <div className="min-w-0 space-y-1" data-testid={testId}>
      <div className="flex items-center gap-2">
        <span className="label-mono">{title}</span>
        <a href={href} target="_blank" rel="noreferrer" className="text-[10px] underline truncate">Open</a>
      </div>
      <div className="flex flex-wrap gap-1">{items.length ? items.map((p, i) => <Chip key={i} p={p} />) : <span className="text-[11px] text-red-700">No pixels</span>}</div>
      <Live v={live} testId={`${testId}-live`} />
    </div>
  );
}

export function PixelCheckRow({ r, origin, live, liveFresh }) {
  const [Icon, cls, word] = STATUS[r.status];
  const lv = live || r.live || {};
  const old = !live && r.live && !liveFresh;
  return (
    <li className="p-3 space-y-2" data-testid={`pixel-row-${r.key}`}>
      <div className="flex items-center gap-2 flex-wrap">
        <Icon size={16} weight="fill" className={cls} />
        <span className="font-bold text-sm">{r.name}</span>
        <span className="text-[10px] uppercase tracking-widest border border-black px-1">{KIND_TAG[r.kind]}</span>
        <span className={`ml-auto text-[10px] uppercase tracking-widest font-bold ${cls}`} data-testid={`pixel-row-status-${r.key}`}>{word}</span>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        <Surface title="Page" items={r.landing} live={lv.landing} href={`${origin}${r.url}`} testId={`pixel-row-page-${r.key}`} />
        <Surface title="Thank-you page" items={r.thank_you} live={lv.thank_you} href={`${origin}${r.thank_you_url}`} testId={`pixel-row-ty-${r.key}`} />
      </div>
      {old && <div className="text-[10px] text-zinc-500" data-testid={`pixel-row-live-old-${r.key}`}>Live results are over 2 days old. Run the live test again.</div>}
      {r.problems.length > 0 && (
        <ul className="text-[11px] space-y-0.5" data-testid={`pixel-row-problems-${r.key}`}>
          {r.problems.map((p) => (
            <li key={p.text} className={p.level === "warn" ? "text-amber-800" : "text-zinc-500"}>{p.text}</li>
          ))}
        </ul>
      )}
    </li>
  );
}
